const getters = {
  sidebar: (state) => state.app.sidebar,
  device: (state) => state.app.device,
  token: (state) => state.user.token,
  avatar: (state) => state.user.avatar,
  name: (state) => state.user.name,
  visitedViews: (state) => state.tagsView.visitedViews,
  cachedViews: (state) => state.tagsView.cachedViews,
  permission_routes: (state) => state.permission.routes,
  roles: (state) => state.user.roles,
  orderCache: (state) => state.productOrder.orderCache,
  pageInfo: (state) => state.commonSavePage.pageInfo, // 要追加声明
  factory: (state) => state.adminSelectFactory.factory, // 要追加声明
  role: (state) => state.role.role,
};
export default getters;
